<portal-page [showBackground]="true" design="box">
  @if (!loaded) {
    @if (showError) {
      <ebeihilfe-note [messageText]="errorMessage | translate" type="danger" />
    }
    @for (group of faqList$ | async; track group.id) {
      <div class="faq-group">
        <h2 class="mat-h4">{{ group.categoryName }}</h2>
        <mat-accordion>
          @for (faq of group.faqItems; track faq.id) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span class="translation-text">{{ faq.header }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div [innerHTML]="faq.body"></div>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
    }
  } @else {
    <mat-spinner class="spinner" />
    <span class="screen-reader-only">Lade...</span>
  }
</portal-page>
